"use strict";

import {
     dashboardConstants,
     commonConstants,
     responseCodes,
} from "../_constants";

export const INITIAL_DASHBOARD_STATE = {
     dashboardSummary: null,
     dashBoardActivationSummary: null,
     dashBoardTLCActivationSummary: null,
     dashBoardRewardIssueCampaignSummary: null,
     dashBoardUserLoginSummary: null,
     dashBoardPageViewSummary: null,
     dashBoardComsPageViewSummary: null,
     dashboardEmailTrackingSummary: null,
     dashboardEmailDispatchSummary: null,
     dashboardQ4OilMasterSummary: null,
     dashboardQ4WearTearSummary: null,
     dashboardAbuDahbiSummary: null,
     dashboardDeviceusedSummary: null,
     areaList: [],
     leagueSummary:[],
     notification:[],
     tlcAreaList:[],
     dashboardRewardIssueDownload: null,
     dashboardParticipantActivationDownload: null,
     dashboardUserLoginDownload: null,
     dashboardEmailTrackingDownload:null,
     dashboardEmailDispatchDownload:null,
     dashboardCommsPageViewDownload:null,
     dashboardDevicedUsedDownload: null,
     dashboardCampaignPageViewSummaryDownload: null,
     dashboardParticipantsSliderCardDownload: null,
     dashboardLocationSliderCardDownload: null,
     dashboardGetMostActiveData: null,
};

export function dashboard(state = INITIAL_DASHBOARD_STATE, action) {
     switch (action.type) {
          case dashboardConstants.DASHBOARD_GET_AREA_LIST_COMPLETE:
               return {
                    ...state,
                    areaList: action.payload,
               };
          case dashboardConstants.DASHBOARD_GET_TLC_AREA_LIST_COMPLETE:
               return {
                    ...state,
                    tlcAreaList: action.payload,
               };
          case dashboardConstants.DASHBOARD_GET_Q4_OILMASTER_SUMMARY_COMPLETE:
               return {
                    ...state,
                    dashboardQ4OilMasterSummary: action.payload,
               };

          case dashboardConstants.DASHBOARD_GET_WEAR_TEER_SUMMARY_COMPLETE:
               return {
                    ...state,
                    dashboardQ4WearTearSummary: action.payload,
               };

          case dashboardConstants.DASHBOARD_GET_ABUDAHBI_SUMMARY_COMPLETE:
               return {
                    ...state,
                    dashboardAbuDahbiSummary: action.payload,
               };

          case dashboardConstants.DASHBOARD_GET_DASHBOARD_SUMMARY_COMPLETE:
               return {
                    ...state,
                    dashboardSummary: action.payload,
               };
          case dashboardConstants.DASHBOARD_GET_AREA_MANAGER_LEAGUES_RANK_SUMMARY_COMPLETE:
               return {
                    ...state,
                    leagueSummary: action?.payload?.data,
               };

          case dashboardConstants.DASHBOARD_GET_PARTICIPANT_ACTIVATION_SUMMARY_COMPLETE:
               const requiredCategories = ["Service Manager", "Service Advisor", "Area Manager"];
               const filteredData = action?.payload?.filter(item => requiredCategories.includes(item.jobRole));

               const chartData = {
                    categories: requiredCategories,
                    chartDataList: [
                        {
                            name: "Total Registered",
                            values: filteredData.map(item => item.totalRegistered)
                        },
                        {
                            name: "Activated",
                            values: filteredData.map(item => item.activated)
                        },
                        {
                            name: "Non Activated",
                            values: filteredData.map(item => item.nonactivated)
                        },
                        {
                         name: "Deactivated",
                         values: filteredData.map(item => item.deactivated)
                        }
                    ]
                };

               return {
                    ...state,
                    dashBoardActivationSummary: {
                         ...chartData,
                         exelFormat: chartData,
                    },
               };

          case dashboardConstants.DASHBOARD_GET_TLC_PARTICIPANT_ACTIVATION_SUMMARY_COMPLETE:
               const requiredTLCCategories = ["Customer", "Trade Area Manager"];
               const filteredTLCData = action?.payload?.filter(item => requiredTLCCategories.includes(item.jobRole));

               const chartTLCData = {
                    categories: requiredTLCCategories,
                    chartDataList: [
                         {
                              name: "Total Registered",
                              values: filteredTLCData.map(item => item.totalRegistered)
                         },
                         {
                              name: "Activated",
                              values: filteredTLCData.map(item => item.activated)
                         },
                         {
                              name: "Non Activated",
                              values: filteredTLCData.map(item => item.nonactivated)
                         },
                         {
                         name: "Deactivated",
                         values: filteredTLCData.map(item => item.deactivated)
                         }
                    ]
                    };
                    
               return {
                    ...state,
                    dashBoardTLCActivationSummary: {
                         ...chartTLCData,
                         exelFormat: chartTLCData,
                    },
               };

          case dashboardConstants.DASHBOARD_GET_REWARD_ISSUED_BY_CAMPAIGN_COMPLETE:
               const mappedData = action.payload.categories.map(
                    (category, index) => ({
                         Category: category,
                         Value: action.payload.data[index],
                    }),
               );

               return {
                    ...state,
                    dashBoardRewardIssueCampaignSummary: {
                         ...action.payload,
                         exelFormat: mappedData,
                    },
               };
          
          case dashboardConstants.DASHBOARD_REWARD_ISSUED_BY_DOWNLOAD_COMPLETE:

               return {
                    ...state,
                    dashboardRewardIssueDownload: action.payload,
               };

          case dashboardConstants.DASHBOARD_PARTICIPANT_ACTIVATION_DOWNLOAD_COMPLETE:

               return {
                    ...state,
                    dashboardParticipantActivationDownload: action.payload,
               };
          
          case dashboardConstants.DASHBOARD_USER_LOGIN_SUMMARY_DOWNLOAD_COMPLETE:

               return {
                    ...state,
                    dashboardUserLoginDownload: action.payload,
               };

          case dashboardConstants.DASHBOARD_EMAIL_TRACKING_DOWNLOAD_COMPLETE:

               return {
                    ...state,
                    dashboardEmailTrackingDownload: action.payload,
               };
          case dashboardConstants.DASHBOARD_EMAIL_DISPATCH_DOWNLOAD_COMPLETE:

               return {
                    ...state,
                    dashboardEmailDispatchDownload: action.payload,
               };
          case dashboardConstants.DASHBOARD_COMMS_PAGE_VIEW_DOWNLOAD_COMPLETE:

               return {
                    ...state,
                    dashboardCommsPageViewDownload: action.payload,
               };
          case dashboardConstants.DASHBOARD_DEVICED_USED_SUMMARY_DOWNLOAD_COMPLETE:

               return {
                    ...state,
                    dashboardDevicedUsedDownload: action.payload,
               };

          case dashboardConstants.DASHBOARD_CAMPAIGN_PAGE_VIEW_SUMMARY_DOWNLOAD_COMPLETE:
               return {
                    ...state,
                    dashboardCampaignPageViewSummaryDownload: action.payload,
               };

          case dashboardConstants.DASHBOARD_PARTICIPANTS_SILDERCARD_DOWNLOAD_COMPLETE:
                    return {
                         ...state,
                         dashboardParticipantsSliderCardDownload: action.payload,
                    };
          case dashboardConstants.DASHBOARD_LOCATION_SILDERCARD_DOWNLOAD_COMPLETE:
               return {
                    ...state,
                    dashboardLocationSliderCardDownload: action.payload,
               };


          case dashboardConstants.DASHBOARD_GET_PARTICIPANT_LOGIN_SUMMARY_COMPLETE:
               const exelFormat = action.payload.categories.map(
                    (date, index) => {
                         const entry = { date };
                         action.payload.chartDataList.forEach(
                              ({ name, values }) => {
                                   const key = name.replace(" ", "_");
                                   entry[key] = values[index];
                              },
                         );
                         return entry;
                    },
               );

               return {
                    ...state,
                    dashBoardUserLoginSummary: {
                         ...action.payload,
                         exelFormat,
                    },
               };
          case dashboardConstants.DASHBOARD_GET_CAMPAIGN_PAGE_VIEW_SUMMARY_COMPLETE:
               const exelFormatCampaign = action.payload.categories.map(
                    (date, index) => {
                         const entry = { date };
                         action.payload.chartDataList.forEach(
                              ({ name, values }) => {
                                   const key = name.replace(" ", "_");
                                   entry[key] = values[index];
                              },
                         );
                         return entry;
                    },
               );
               return {
                    ...state,
                    dashBoardPageViewSummary: {
                         ...action.payload,
                         exelFormat: exelFormatCampaign,
                    },
               };
          case dashboardConstants.DASHBOARD_GET_COMMS_PAGE_VIEW_COMPLETE:
               const exelFormatComms = action.payload.categories.map(
                    (date, index) => {
                         const entry = { date };
                         action.payload.chartDataList.forEach(
                              ({ name, values }) => {
                                   const key = name.replace(" ", "_");
                                   entry[key] = values[index];
                              },
                         );
                         return entry;
                    },
               );
               return {
                    ...state,
                    dashBoardComsPageViewSummary: {
                         ...action.payload,
                         exelFormat: exelFormatComms,
                    },
               };

          case dashboardConstants.GET_DEVICED_USED_SUMMARY_COMPLETE:
               const categoriesDevices = [
                    ...new Set(
                         action.payload.map((item) => {
                              const date = new Date(item.date);
                              return `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}`;
                         }),
                    ),
               ];

               const chartDataListDevices = [
                    {
                         name: "desktopCount",
                         values: Array(categoriesDevices.length).fill(0),
                    },
                    {
                         name: "mobileCount",
                         values: Array(categoriesDevices.length).fill(0),
                    },
               ];

               // Fill in values based on categories
               action.payload.forEach((item) => {
                    const date = new Date(item.date);
                    const formattedDate = `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}`;
                    const index = categoriesDevices.indexOf(formattedDate);

                    if (index !== -1) {
                         chartDataListDevices[0].values[index] +=
                              item.desktopCount;
                         chartDataListDevices[1].values[index] +=
                              item.mobileCount;
                    }
               });

               const formatData = {
                    categories: categoriesDevices,
                    chartDataList: chartDataListDevices,
               };

               const exelFormatDeviceUsed = formatData.categories.map(
                    (date, index) => {
                         const entry = { date };
                         formatData.chartDataList.forEach(
                              ({ name, values }) => {
                                   const key = name.replace(" ", "_");
                                   entry[key] = values[index];
                              },
                         );
                         return entry;
                    },
               );

               return {
                    ...state,
                    dashboardDeviceusedSummary: {
                         categories: categoriesDevices,
                         chartDataList: chartDataListDevices,
                         exelFormat: exelFormatDeviceUsed,
                    },
               };

          case dashboardConstants.DASHBOARD_GET_EMAIL_TRACKING_SUMMARY_COMPLETE:
               const categories = action.payload.emailStats.map((item) => {
                    const date = new Date(item.date);
                    const day = date.getDate().toString().padStart(2, "0");
                    const month = (date.getMonth() + 1)
                         .toString()
                         .padStart(2, "0");
                    return `${day}/${month}`;
               });

               const chartDataList = [
                    {
                         name: "emailRequests",
                         values: Array(categories.length).fill(0),
                    },
                    {
                         name: "deliveredEmails",
                         values: Array(categories.length).fill(0),
                    },
                    {
                         name: "openedEmails",
                         values: Array(categories.length).fill(0),
                    },
                    {
                         name: "clickedEmails",
                         values: Array(categories.length).fill(0),
                    },
                    {
                         name: "bouncedEmails",
                         values: Array(categories.length).fill(0),
                    },
                    {
                         name: "spamReportsEmails",
                         values: Array(categories.length).fill(0),
                    },
               ];

               action.payload.emailStats.forEach((item, index) => {
                    const stats = item.stats[0]; // Accessing the stats object for each date
                    chartDataList[0].values[index] = stats.emailRequests;
                    chartDataList[1].values[index] = stats.deliveredEmails;
                    chartDataList[2].values[index] = stats.openedEmails;
                    chartDataList[3].values[index] = stats.clickedEmails;
                    chartDataList[4].values[index] = stats.bouncedEmails;
                    chartDataList[5].values[index] = stats.spamReportsEmails;
               });

               const formattedData = {
                    categories: categories,
                    chartDataList: chartDataList,
                    totalBouncedEmails: action.payload.totalBouncedEmails,
                    totalClickedEmails: action.payload.totalClickedEmails,
                    totalDeliveredEmails: action.payload.totalDeliveredEmails,
                    totalEmailRequests: action.payload.totalEmailRequests,
                    totalOpenedEmails: action.payload.totalOpenedEmails,
                    totalSpamReportsEmails:
                         action.payload.totalSpamReportsEmails,
                    failedStats: action.payload.failedStats,
               };

               return {
                    ...state,
                    dashboardEmailTrackingSummary: formattedData,
               };

          case dashboardConstants.DASHBOARD_GET_EMAIL_DISPATCH_SUMMARY_COMPLETE:
               // Helper function to format a date as "DD/MM"
               function formatDate(date) {
                    return date.toLocaleDateString("en-GB").slice(0, 5); // Convert to "DD/MM"
               }

               // Helper function to get all dates between two dates
               function getDateRange(startDate, endDate) {
                    const dates = [];
                    let currentDate = new Date(startDate);
                    while (currentDate <= endDate) {
                         dates.push(formatDate(currentDate));
                         currentDate.setDate(currentDate.getDate() + 1);
                    }
                    return dates;
               }

               const dates = action.payload.result.map(
                    (entry) => new Date(entry.sendAt),
               );
               const minDate = new Date(Math.min(...dates));
               const maxDate = new Date(Math.max(...dates));

               // Generate categories dynamically based on min and max dates
               const dateRange = getDateRange(minDate, maxDate);

               // Initialize emailTemp structure
               const emailTemp = {
                    categories: dateRange,
                    chartDataList: [],
               };

               // Populate chartDataList
               action.payload.result.forEach((entry) => {
                    const sendDate = formatDate(new Date(entry.sendAt));
                    const dateIndex = dateRange.indexOf(sendDate);

                    // Initialize values array with zeros for each date in categories
                    const values = Array(dateRange.length).fill(0);

                    if (dateIndex !== -1) {
                         // Set the emailsSent value at the correct index
                         values[dateIndex] = entry.emailsSent;
                    }

                    // Add entry to chartDataList
                    emailTemp.chartDataList.push({
                         name: entry.name,
                         values: values,
                    });
               });

               return {
                    ...state,
                    dashboardEmailDispatchSummary: {
                         ...emailTemp,
                         exelFormat: action.payload.result,
                    },
               };

               case dashboardConstants.DASHBOARD_GET_NOTIFICATIONS_COMPLETE:
                    return {
                         ...state,
                         notification: action.payload.data,
                    };
               case dashboardConstants.DASHBOARD_GET_MOST_ACTIVE_DETAILS_CHART_COMPLETE:
                    return {
                         ...state,
                         dashboardGetMostActiveData: action.payload.data,
                    };
     }

     return state;
}
